import { render, staticRenderFns } from "./DirecTVView.vue?vue&type=template&id=5b567099&scoped=true&"
import script from "./DirecTVView.vue?vue&type=script&lang=ts&"
export * from "./DirecTVView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b567099",
  null
  
)

export default component.exports